export function isPrerenderUserAgent() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const userAgent = String(navigator.userAgent || "");
  const host = String(window.location?.hostname || "").toLowerCase();
  const port = String(window.location?.port || "");

  return /ReactSnap/i.test(userAgent) || (host === "localhost" && port === "45678");
}
